/**
 * lazyloads carousel images
 * @module product-zoom
 */
 import $ from 'jquery';
 import Cookies from 'js-cookie';

 // import registerJQueryPlugin from '../lib/register-jquery-plugin';

 export const DEFAULTS = {
   markupLink: '',
 };

 const COOKIE_NAME = 'signUpModal';

/**
* Merges together all the options and the various conditions in which they
* can be set.
* @param  {jQuery} $el - The container element
* @param  {Object} [options={}] - Any options provided upon initialization
* @return {Object} Immutable version of the options
*/
 const mergeOptions = (DEFAULTS = {}, options = {}) => {
   const opts = $.extend({}, DEFAULTS, options);
   return opts;
 };
 // set cookie
 const SET_COOKIE = () => {
   Cookies.set(COOKIE_NAME, true);
 };
 const INITIALIZE_MODAL = (opts) => {
   SET_COOKIE();
   $.modal({
     url: opts.markupLink,
     type: 'small',
     triggerOpen: true,
     onComplete() {
       window.initFloatingLabels();
     },
       onClose(){
         if (typeof window.PAGE_TRACK_A_MODULE !== 'undefined' && $.isFunction(window.PAGE_TRACK_A_MODULE.insertEventTrack)) {
             window.PAGE_TRACK_A_MODULE.insertEventTrack('news_letter_dialog', 'close_dialog');
         }

       }
   });
 };

 // get cookie value
 const GET_COOKIE = () => {
   const cookieValue = Cookies.get(COOKIE_NAME);
   return cookieValue;
 };
 // show button if cookie
 const CHECK_COOKIE = (opts) => {
   const showNewsletterModal = window.location.href.indexOf('/checkout/') === -1;
   if (showNewsletterModal && !GET_COOKIE() === true) {
     INITIALIZE_MODAL(opts);
   }
 };

/**
 * Applies any sort of event handlers for the toggleContent.
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
 const applyEventHandlers = (opts) => {
   CHECK_COOKIE(opts);
 };

/**
 * Initializes an toggleContent based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
 export default function signUpModal(options = {}) {
   const opts = mergeOptions(DEFAULTS, options);
   applyEventHandlers(opts);
 }

 // Expose the function as a jQuery plugin for ease of use
 // registerJQueryPlugin(PLUGIN_NAME, productZoom);

 window.signUpForNewsletter = (emailVal, el) => {
   $.ajax({
     type: 'POST',
     url: '/account/ajax/signUpForNewsLetter',
     data: $.param({
       email: emailVal,
       site: 'ALF',
     }),
     success(data) {
       // const { success } = $.parseJSON(data);

       if (data.success) {
         $.modal({
           type: 'notification',
           triggerOpen: true,
           url: '/dialog/newsletter-confirmation',
         });
         if (typeof window.PAGE_TRACK_A_MODULE !== 'undefined' && $.isFunction(window.PAGE_TRACK_A_MODULE.insertEventTrack)) {
           window.PAGE_TRACK_A_MODULE.insertEventTrack('news_letter_dialog', 'subscribe', 'email:' + emailVal);
         }
       } else if (data.duplicate) {
         $('.js-sign-up-modal-error').show();
       } else if (el && typeof el.invalidate === 'function') {
         el.invalidate({
           message: 'Please put a valid e-mail address',
         });
       }
     },
   });
 };



// WEBPACK FOOTER //
// ./src/scripts/modules/sign-up.js